import client from './SharedConfig';

export const createAlarm = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/dashboard/alarm/create/',
        data: body,
        headers: header
    };
    return client.request(config )
};

export const getAllMyAlarms = ({parameter={}, header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/user/alarm/list/',
        params: parameter,
        headers: header
    };
    return client.request(config )
};

export const getAlarmDetails = ({header={}} = {}, id="0") => {
    const config = {
        method: 'GET',
        url: `advertisement/alarm/detail/${id}/`,
        headers: header
    };
    return client.request(config )
};

export const getAlarmRelatedAds = ({parameter={}, header={}, id="0"} = {}) => {
    const config = {
        method: 'GET',
        url: `advertisement/alarm/ads/list/${id}/`,
        params: parameter,
        headers: header
    };
    return client.request(config )
};

export const removeAlarm = ({header={}} = {}, id="0") => {
    const config = {
        method: 'DELETE',
        url: `advertisement/dashboard/alarm/delete/${id}/`,
        headers: header
    };
    return client.request(config )
};